import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { CardBackgroundUpdateService } from '../card/card-background-update.service';
import { AlertFactory } from '../display-info-icon-factory/alert-factory';
import { ClimateControlSensorDisplayIconFactory } from '../display-info-icon-factory/climate-control-sensor-display-icon-factory';
import { FanFactory } from '../display-info-icon-factory/fan-factory';
import { GaugeFactory } from '../display-info-icon-factory/gauge-factory';
import { GeneralDisplayIconFactory } from '../display-info-icon-factory/general-display-icon-factory';
import { HoodFanFactory } from '../display-info-icon-factory/hood-fan-factory';
import { HoodLightFactory } from '../display-info-icon-factory/hood-light-factory';
import { LightFactory } from '../display-info-icon-factory/light-factory';
import { MaterialDisplayIconFactory } from '../display-info-icon-factory/material-display-icon-factory';
import { OccupiedFactory } from '../display-info-icon-factory/occupied-factory';
import { RoomFanFactory } from '../display-info-icon-factory/room-fan-factory';
import { TemperatureDisplayIconFactory } from '../display-info-icon-factory/temperature-display-icon-factory';
import { WashFactory } from '../display-info-icon-factory/wash-factory';
import { GraphicBehaviorType } from '../shared/models/graphic-behavior-type.enum';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class GraphicBehaviorIconCreator {
    constructor(private cardBackgroundChangeService: CardBackgroundUpdateService) {}

    public createGraphicBehavior(item: ICardDataViewModel): IDisplayInfoIcon {
        switch (item.graphicBehavior) {
            case GraphicBehaviorType.ALERT:
                return new AlertFactory().createDisplayIcon(item);
            case GraphicBehaviorType.FAN_HOOD:
                return new HoodFanFactory().createDisplayIcon(item);
            case GraphicBehaviorType.FAN_ROOM:
                return new RoomFanFactory().createDisplayIcon(item);
            case GraphicBehaviorType.BLOWER:
            case GraphicBehaviorType.BLOWER_UNOCCUPIED:
            case GraphicBehaviorType.FAN:
                return new FanFactory().createDisplayIcon(item);
            case GraphicBehaviorType.WASH:
                return new WashFactory().createDisplayIcon(item);
            case GraphicBehaviorType.LIGHT_HOOD:
                return new HoodLightFactory().createDisplayIcon(item);
            case GraphicBehaviorType.LIGHT_ROOM:
            case GraphicBehaviorType.LIGHT:
                return new LightFactory().createDisplayIcon(item);
            case GraphicBehaviorType.CLIMATE_CONTROL_STATE_SENSOR:
                return new ClimateControlSensorDisplayIconFactory(this.cardBackgroundChangeService).createDisplayIcon(item);
            case GraphicBehaviorType.GAUGE:
                return new GaugeFactory().createDisplayIcon(item);
            case GraphicBehaviorType.OCCUPIED_SENSOR:
                return new OccupiedFactory().createDisplayIcon(item);
            case GraphicBehaviorType.TEMPERATURE_DIFFERENTIAL_SENSOR:
            case GraphicBehaviorType.TEMPERATURE_SENSOR:
                return new TemperatureDisplayIconFactory().createDisplayIcon(item);
            case GraphicBehaviorType.RELATIVE_HUMIDITY_SENSOR:
            case GraphicBehaviorType.TEMPERATURE_COLD_SENSOR:
            case GraphicBehaviorType.TEMPERATURE_COLD_UNOCCUPIED_SENSOR:
            case GraphicBehaviorType.TEMPERATURE_HOT_SENSOR:
            case GraphicBehaviorType.TEMPERATURE_HOT_UNOCCUPIED_SENSOR:
                return new GeneralDisplayIconFactory().createDisplayIcon(item);
            default:
                return new MaterialDisplayIconFactory().createDisplayIcon(item);
        }
    }
}
